// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6996":"css/admin-app.6717","7649":"css/app.6717"}[chunkId] + ".css";
};